import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import BuildIcon from "@material-ui/icons/Build";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import HomeIcon from "@material-ui/icons/Home";
import Badge from "@material-ui/core/Badge";
import AppConfig from "../../../config/appconfig.json";
import moment from "moment";

const styles = {
  root: {
    //width: 500
    //"background-color": "#CCFFFF"
  },
  badge: {
    top: -30,
    right: -15
  }
};

class SimpleBottomNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : 0,
      statServices: 0,
      statPayments: 0
    };
  }

  componentDidMount() {
    const kbeSid = localStorage.getItem("kbeSid");
    let isCheckInvoiceFailed = false;
    // Call Back-End Services
    fetch(`${AppConfig.BACK_END_URL}/APIClient/CheckInvoice?client=` + kbeSid)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isCheckInvoiceFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isCheckInvoiceFailed) {
          const invoiceList = localStorage.getItem("CheckInvoice");
          if (invoiceList) {
            const respObj = JSON.parse(invoiceList);
            const totalPaymentDue = respObj.filter(e => e.PaymentDue !== "");
            this.setState({ statPayments: totalPaymentDue.length });
          }
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          if (respObj) {
            const totalPaymentDue = respObj.filter(e => e.PaymentDue !== "");
            this.setState({ statPayments: totalPaymentDue.length });
            localStorage.setItem("CheckInvoice", JSON.stringify(respObj));
          }
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when checking invoice. Please try again."
        );
        const invoiceList = localStorage.getItem("CheckInvoice");
        if (invoiceList) {
          const respObj = JSON.parse(invoiceList);
          const totalPaymentDue = respObj.filter(e => e.PaymentDue !== "");
          this.setState({ statPayments: totalPaymentDue.length });
        }
      });

    let isretrieveCustomerSystemFailed = false;
    // Call Back-End Services
    fetch(
      `${AppConfig.BACK_END_URL}/APIClient/RetrieveCustomerSystem?Sid=` +
      kbeSid
    )
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isretrieveCustomerSystemFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isretrieveCustomerSystemFailed) {
          const custSys = localStorage.getItem("RetrieveCustomerSystem");
          if (custSys) {
            const respObj = JSON.parse(custSys);
            const totalServicesDue = respObj.filter(e => moment(e.ServicingDue, "DD MMM YYYY") <= moment());
            // console.log(totalServicesDue);
            this.setState({ statServices: totalServicesDue.length });
          }
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          if (respObj) {
            const totalServicesDue = respObj.filter(e => moment(e.ServicingDue, "DD MMM YYYY") <= moment());
            // console.log(totalServicesDue);
            this.setState({ statServices: totalServicesDue.length });
          }
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when retrieving customer systems. Please try again."
        );
        const custSys = localStorage.getItem("RetrieveCustomerSystem");
        if (custSys) {
          const respObj = JSON.parse(custSys);
          const totalServicesDue = respObj.filter(e => moment(e.ServicingDue, "DD MMM YYYY") <= moment());
          // console.log(totalServicesDue);
          this.setState({ statServices: totalServicesDue.length });
        }
      });
  }

  handleChange = (event, value) => {
    this.setState({ value });
    switch (value) {
      case 0:
        window.location = "/";
        break;
      case 1:
        window.location = "/register_appt";
        break;
      case 2:
        window.location = "/services";
        break;
      case 3:
        window.location = "/invoices";
        break;
      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div style={{ position: "fixed", bottom: "0", width: "100%", left: "0" }}>
        <BottomNavigation
          value={value}
          onChange={this.handleChange}
          showLabels
          className={classes.root}
        >
          <BottomNavigationAction label="Home" icon={<HomeIcon />} />
          <BottomNavigationAction
            label="Appointment"
            icon={<CalendarIcon />}
            disabled={this.props.disabled}
          />
          <BottomNavigationAction
            label={
              this.state.statServices > 0 ? (
                <Badge
                  color="secondary"
                  badgeContent={this.state.statServices}
                  classes={{ badge: classes.badge }}
                >
                  Service
              </Badge>
              ) : ("Service")
            }
            icon={<BuildIcon />}
            disabled={this.props.disabled}
          />
          <BottomNavigationAction
            label={
              this.state.statPayments > 0 ? (
                <Badge
                  color="secondary"
                  badgeContent={this.state.statPayments}
                  classes={{ badge: classes.badge }}
                >
                  Payment
              </Badge>
              ) : ("Payment")
            }
            icon={<AssignmentIcon />}
            disabled={this.props.disabled}
          />
        </BottomNavigation>
      </div>
    );
  }
}

SimpleBottomNavigation.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleBottomNavigation);



// WEBPACK FOOTER //
// ./src/pages/main/components/SimpleBottomNav.js